import { render, staticRenderFns } from "./video-modal.vue?vue&type=template&id=23e606dd&scoped=true&"
import script from "./video-modal.vue?vue&type=script&lang=js&"
export * from "./video-modal.vue?vue&type=script&lang=js&"
import style0 from "./video-modal.vue?vue&type=style&index=0&id=23e606dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e606dd",
  null
  
)

export default component.exports